<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form @submit.prevent="LoginHandel">
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Login form</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                      v-model="formdata.email"
                      prepend-icon="mdi-account"
                      name="login"
                      label="Login"
                      type="text"
                  ></v-text-field>
                  <v-text-field
                      v-model="formdata.password"
                      id="password"
                      prepend-icon="mdi-lock"
                      name="password"
                      label="Password"
                      type="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import atshq from "../../js/setup";
import axiosAdmin from "../../js/setup";

export default {
  data() {
    return {
      name: "Login",
      appUrl: axiosAdmin.defaults.headers.common['app_URL'],
      formdata: {
        email: "",
        password: "",
      },
      props: {
        source: String,
      },
    };
  },

  created() {
  },

  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("identity") && urlParams.has("password")) {
      this.formdata.email = urlParams.get("identity");
      this.formdata.password = urlParams.get("password");
      this.$router.replace({'query': null})
      this.LoginHandel();
    }

    if (parseInt(urlParams.get('user_id'))) {
      if (parseInt(urlParams.get('user_id')) !== parseInt(localStorage.getItem('user_id'))) {
        window.open(atshq.defaults.headers.common.app_URL + "index.php/auth/logout");
        localStorage.setItem("token", "");
        localStorage.setItem("userId", "");
        localStorage.setItem("userName", "");
        localStorage.setItem("specialPower", "");
        localStorage.setItem("userGroups", []);
        localStorage.setItem("user_permissions", "");
        window.location.href = "/";
      }
    }

  },
  methods: {
    LoginHandel() {
      atshq
          .post("login", this.formdata)
          .then((response) => {
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem("userId", response.data.user.id);
            localStorage.setItem("userName", response.data.user.full_name);
            localStorage.setItem("specialPower", String(response.data.user.special_power || 0));
            localStorage.setItem("userGroups", JSON.stringify(response.data.user_groups || []));
            localStorage.setItem("user_permissions", JSON.stringify(response.data.user_permissions || []));
            localStorage.setItem("user_role", String(response.data.user.role_id || ''));
            localStorage.setItem("userId", String(response.data.user.id || ''));
            this.$noty.success(response.data.message);
            this.$router.replace({'query': null})
            window.location.reload();
            window.location.href = this.appUrl + 'auth/loginUsingParameter?identity=' + this.formdata.email + '&password=' + this.formdata.password

          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
  },
};
</script>

<style></style>
